import ViewTransferReturn from "../../../../components/@documents/transfer_returns/ViewTransferReturn";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function TransferReturnViewPage() {

    return (
        <ViewTransferReturn 
            routeType={routeTypes.retail}
        />
    )
}